angular.module('autoremind.dashboard.directives')
    .directive('resellerWidget', ['$parse', 'dashboardService', '$interval', 'resellerService', '$rootScope', function ($parse, dashboardService, $interval, resellerService, $rootScope) {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/dashboard/widgets/reseller/reseller.html',
            link: function (scope, elem, attr) {
                scope.params = $parse(attr.params)(scope);
                scope.viewModel = {
                    stats: {
                        customerCount: null
                    },
                    updateInterval: angular.isDefined(scope.params.settings) && angular.isDefined(scope.params.settings.updateInterval) ? scope.params.settings.updateInterval : false,
                    isBusy: false
                };
                scope.getStats = function () {
                    if (scope.viewModel.isBusy) {
                        return;
                    }
                    scope.viewModel.isBusy = true;
                    resellerService.getStats()
                        .then(function (data) {
                        scope.viewModel.isBusy = false;
                        scope.viewModel.stats.customerCount = resellerService.viewModel.stats.customerCount;
                    }, function () {
                        scope.viewModel.isBusy = false;
                    });
                };
                scope.getStats();
                scope.stopHandler = null;
                /* We should not keep updating due to limited number of requests to the ZOHO API, so user must refresh
                            if (scope.viewModel.updateInterval) {
                                scope.stopHandler = $interval(function () {
                                    scope.getStats();
                                }, Math.abs(scope.viewModel.updateInterval) )
                            }
                */
                scope.$on("$locationChangeStart", function (event, next, current) {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                });
                $rootScope.$on('event:auth-logout', function () {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                });
            }
        };
    }]);
//# sourceMappingURL=reseller.js.map